import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
  faTiktok,
  faXTwitter,
  faYoutube,
  faPinterestP
} from "@fortawesome/free-brands-svg-icons";
import "./RightElements.css";

const SocialElements = () => (
  <div className="social-elements">
    <a href="https://www.instagram.com/conta_learn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FontAwesomeIcon icon={faInstagram} /></a>
    <a href="https://www.linkedin.com/company/contalearn" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FontAwesomeIcon icon={faLinkedinIn} /></a>
  </div>
);

export default SocialElements;
